import {clearSentryUser} from "@/config/sentry";

class AuthHelpers {
  is_user_login() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user !== null;
  }

  auth() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user;
  }

  auth_user_id() {
    return JSON.parse(localStorage.getItem("user"))["data"]["id"];
  }

  auth_admin_id() {
    if (JSON.parse(localStorage.getItem("user"))["data"]["admin"]) {
      return JSON.parse(localStorage.getItem("user"))["data"]["admin"]["id"];
    }

    return null;
  }

  auth_manager_id() {
    if (JSON.parse(localStorage.getItem("user"))["data"]["manager"]) {
      return JSON.parse(localStorage.getItem("user"))["data"]["manager"]["id"];
    }

    return null;
  }

  auth_team_leader_id() {
    if (JSON.parse(localStorage.getItem("user"))["data"]["team_leader"]) {
      return JSON.parse(localStorage.getItem("user"))["data"]["team_leader"][
        "id"
      ];
    }

    return null;
  }

  auth_service_engineer_id() {
    if (JSON.parse(localStorage.getItem("user"))["data"]["service_engineer"]) {
      return JSON.parse(localStorage.getItem("user"))["data"][
        "service_engineer"
      ]["id"];
    }

    return null;
  }

  auth_service_desk_id() {
    if (JSON.parse(localStorage.getItem("user"))["data"]["service_desk"]) {
      return JSON.parse(localStorage.getItem("user"))["data"]["service_desk"][
        "id"
      ];
    }

    return null;
  }

  auth_remote_operation_center_id() {
    if (
      JSON.parse(localStorage.getItem("user"))["data"][
        "remote_operation_center"
      ]
    ) {
      return JSON.parse(localStorage.getItem("user"))["data"][
        "remote_operation_center"
      ]["id"];
    }

    return null;
  }

  auth_client_id() {
    if (JSON.parse(localStorage.getItem("user"))["data"]["client"]) {
      return JSON.parse(localStorage.getItem("user"))["data"]["client"]["id"];
    }

    return null;
  }

  auth_logistic_staff_id() {
    if (JSON.parse(localStorage.getItem("user"))["data"]["logistic_staff"]) {
      return JSON.parse(localStorage.getItem("user"))["data"]["logistic_staff"][
        "id"
      ];
    }

    return null;
  }

  auth_warehouse_base_id() {
    if (JSON.parse(localStorage.getItem("user"))["data"]["warehouse_base"]) {
      return JSON.parse(localStorage.getItem("user"))["data"]["warehouse_base"][
        "id"
      ];
    }

    return null;
  }

  auth_repair_center_engineer_id() {
    if (JSON.parse(localStorage.getItem("user"))["data"]["repair_center"]) {
      return JSON.parse(localStorage.getItem("user"))["data"]["repair_center"][
        "id"
      ];
    }

    return null;
  }

  auth_comm_vendor_id() {
    if (JSON.parse(localStorage.getItem("user"))["data"]["comm_vendor"]) {
      return JSON.parse(localStorage.getItem("user"))["data"]["comm_vendor"][
        "id"
      ];
    }

    return null;
  }

  auth_name() {
    return JSON.parse(localStorage.getItem("user"))["data"]["name"];
  }

  auth_email() {
    return JSON.parse(localStorage.getItem("user"))["data"]["email"];
  }

  auth_code() {
    return JSON.parse(localStorage.getItem("user"))["data"]["alias"];
  }

  auth_logout() {
    localStorage.removeItem("user");
    clearSentryUser();
  }

  auth_role() {
    let role = "";
    const user = JSON.parse(localStorage.getItem("user"))["data"];

    if (user.manager) {
      role = "manager";
    }

    if (user.team_leader) {
      role = "team_leader";
    }

    if (user.service_desk) {
      role = "service_desk";
    }

    if (user.remote_operation_center) {
      role = "remote_operation_center";
    }

    if (user.client) {
      role = "client";
    }

    if (user.service_engineer) {
      role = "service_engineer";
    }

    if (user.logistic_staff) {
      role = "logistic_staff";
    }

    if (user.repair_center) {
      role = "repair_center";
    }

    if (user.admin) {
      role = "admin";
    }

    if (user.comm_vendor) {
      role = "cv";
    }

    return role;
  }

  auth_token() {
    return JSON.parse(localStorage.getItem("user"))["token"];
  }
}

export default new AuthHelpers();
